import Logger from "../utils/Logger";

// const siteKey = "6Lfbpc8qAAAAAAUADnr8i7yCdk8fjqalPZrNBSOu"; // Replace with your actual site key
const siteKey = "6LcgvlcoAAAAAI4fAQJefl_8M_B14uQ1b_KSrb2Z";
const secretKey = "6LcgvlcoAAAAAGdPJ43QwOJt7I1KPmZx4GjUe1M6";
// const secretKey = "6Lfbpc8qAAAAAP2uMM15DIQvBBQyz9A2CsCA4Uuo"; // Only needed for backend verification

export class ReCaptchaService {
  private static token: string = "";

  private constructor() {}

  // Load reCAPTCHA script dynamically
  static async initiate(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      if (
        !document.querySelector(
          `script[src="https://www.google.com/recaptcha/api.js?render=${siteKey}"]`,
        )
      ) {
        const script = document.createElement("script");
        script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
        script.async = true;
        script.onload = () => resolve();
        script.onerror = () =>
          reject(new Error("Failed to load reCAPTCHA script"));
        document.body.appendChild(script);
      } else {
        resolve();
      }
    });
  }

  // Execute reCAPTCHA and get token
  static async getToken(action: string): Promise<string> {
    if (!window.grecaptcha||process.env.REACT_APP_ENVIORNMENT!=="PRODUCTION") {
      Logger.error("reCAPTCHA not loaded yet.");
      return "";
    }

    return new Promise((resolve, reject) => {
      window.grecaptcha.ready(() => {
        window.grecaptcha
          .execute(siteKey, { action })
          .then((token: string) => {
            this.token = token;
            resolve(token);
          })
          .catch((error: any) => {
            reject(error);
          });
      });
    });
  }

  // Verify token on the backend (replace API URL)
  static async verifyToken(token: string): Promise<boolean> {
    try {
      const response = await fetch(
        "https://www.google.com/recaptcha/api/siteverify",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ secret: secretKey, response: token }),
        },
      );

      const data = await response.json();
      return data.success && data.score >= 0.5;
    } catch (error) {
      console.error("reCAPTCHA verification failed:", error);
      return false;
    }
  }
  //   static showBadge(): void {
  //     const badge = document.querySelector(
  //       ".grecaptcha-badge"
  //     ) as HTMLElement | null;
  //     if (badge) badge.style.display = "block";
  //   }

  //   static hideBadge(): void {
  //     const badge = document.querySelector(
  //       ".grecaptcha-badge"
  //     ) as HTMLElement | null;
  //     if (badge) badge.style.display = "none";
  //   }
}
